import styled from 'styled-components';

import { Container as InputSearchContainer } from '~/components/Form/InputSearch/styles';
import { WEDO_DEFAULT_WIDTH } from '~/styles/breakpoints';
import colors from '~/styles/colors';

export const Container = styled.div`
  width: ${WEDO_DEFAULT_WIDTH};
  font-family: 'Exo 2', sans-serif;

  h2 {
    font-size: 24px;
    font-weight: 600;
    color: #1a1a1a;
    margin: 0;
  }

  ${InputSearchContainer} {
    max-width: 632px;
  }
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 632px;
  margin: 72px auto 20px auto;

  border-bottom: 1px solid #e6e6e6;
  padding-bottom: 16px;
`;

export const Content = styled.div`
  background: ${colors.white};
  padding: 20px 30px;
`;

export const FormContent = styled.div`
  display: block;
  margin: auto;
  max-width: 632px;
`;

export const RequiredFieldsText = styled.p`
  color: ${colors.primary};
`;
